import { checkToFormatLicensingStatus } from './checkToFormatLicensingStatus';

export type ISetDataVehicleInfoToShow = [
  { Status: string },
  { Condutor: string },
  { Placa: string },
  { Renavam: string },
  { Cor: string },
  { 'Ano do Modelo': any },
  { 'Ano de Fabricação': any },
  { Combustível: any },
];

export const setDataVehicleInfoToShow = (
  userVehicleInfo: any,
  driver?: string | null,
): ISetDataVehicleInfoToShow => {
  return [
    {
      Status: checkToFormatLicensingStatus(userVehicleInfo?.vehicle).label,
    },
    { Condutor: driver || 'Não informado' },
    { Placa: userVehicleInfo?.vehicle?.placa },
    {
      Renavam: '*****' + userVehicleInfo?.vehicle?.renavam.slice(-4),
    },
    {
      Cor: userVehicleInfo?.color || 'Não informado',
    },
    {
      'Ano do Modelo': userVehicleInfo?.modelYear || 'Não informado',
    },
    {
      'Ano de Fabricação': userVehicleInfo?.vehicle?.ano || 'Não informado',
    },
    {
      Combustível: userVehicleInfo?.fuelType || 'Não informado',
    },
  ];
};
